import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { configurationApi, type LocalizationProfile } from '../../api/configuration';

export function LocalizationManagerPage() {
  const [profile, setProfile] = useState<LocalizationProfile>({
    language: 'en', timezone: 'Asia/Kolkata', currency: 'INR', date_format: 'DD-MM-YYYY', number_format: 'en-IN',
  });
  const [error, setError] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    void configurationApi.getLocalization().then(setProfile).catch((e) => setError(String(e)));
  }, []);

  async function handleSave(e: React.FormEvent) {
    e.preventDefault();
    try {
      const updated = await configurationApi.updateLocalization(profile);
      setProfile(updated);
      setSaved(true);
    } catch (err) {
      setError(String(err));
    }
  }

  return (
    <div className="mx-auto max-w-2xl p-6">
      <Link to="/configuration" className="text-sm text-blue-600 hover:underline">← Configuration Hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Localization Manager</h1>
      <form onSubmit={(e) => void handleSave(e)} className="mt-6 space-y-4">
        {(['language', 'timezone', 'currency', 'date_format', 'number_format', 'country', 'region'] as const).map((field) => (
          <label key={field} className="block">
            <span className="text-sm capitalize">{field.replace('_', ' ')}</span>
            <input
              value={profile[field] ?? ''}
              onChange={(e) => setProfile({ ...profile, [field]: e.target.value })}
              className="mt-1 w-full rounded border px-3 py-2 dark:border-slate-600 dark:bg-slate-900"
            />
          </label>
        ))}
        <button type="submit" className="rounded bg-blue-600 px-4 py-2 text-white">Save</button>
      </form>
      {saved && <p className="mt-4 text-sm text-green-600">Localization updated.</p>}
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
    </div>
  );
}
